export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? '';

export const INDIA_MAP_CENTER = { lat: 22.5937, lng: 78.9629 };
export const INDIA_MAP_ZOOM = 5;
